import React, { useContext, useEffect, useState } from "react";
import { Form, Button, Container, Figure, Col, Row } from "react-bootstrap";
import MainMemberInfo from "../../components/RegistrationFormComponents.js/MainMemberInfo";
import SpouseInfo from "../../components/RegistrationFormComponents.js/SpouseInfo";
import ResidenceInfo from "../../components/RegistrationFormComponents.js/ResidenceInfo";
import OfficeInformation from "../../components/RegistrationFormComponents.js/OfficeInformation";
import DependentsInfo from "../../components/RegistrationFormComponents.js/DependentsInfo";
import { useForm, useFieldArray } from "react-hook-form";
import AuthContext from "../../hooks/context/AuthContext";
import VillageAddress from "../../components/RegistrationFormComponents.js/VillageAddress";
import { constantTypes } from "../../utils/constants/constant";
import Payment from "../../components/RegistrationFormComponents.js/Payment";
import { signupPayload } from "../../helper/helper";
import moment from "moment";
import SuccessCheck from "../../components/shared/Loader/SuccessCheck";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader } from "lucide-react";

const RegistrationForm = () => {
  let { handleRegister, loading, signupSuccess } = useContext(AuthContext);
  const navigate = useNavigate();

  // HOOK FORM
  const {
    control,
    register,
    setValue,
    clearErrors,
    watch,
    setError,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      familyInformation: [constantTypes.familyInformation],
    },
  });
  // ALL STATE
  const [phone, setPhone] = useState("");
  const [officePhone, setOfficePhone] = useState("");
  const [dobDate, setDobDate] = useState("");
  const [familyMemberDOB, setFamilyMemberDOB] = useState([]);
  const [dateError, setDateError] = useState("");
  const [familyMemberDOBError, setFamilyMemberDOBError] = useState([]);
  const [FamilyPhone, setFamilyPhone] = useState([]);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "familyInformation",
  });
  const [selectedOption, setSelectedOption] = useState("Lifetime");
  const [profilePic, setProfilePic] = useState(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzJtv72esjEWvfSpkux9LhOEGiBQ5vuR8drQ&s"
  );
  const [profileFile, setProfileFile] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);

  const onSubmit = (data) => {
    const isValid = dateValidation(dobDate, familyMemberDOB);
    const dateOfBirth = moment(dobDate).format("YYYY-MM-DD");

    const familyData = data?.familyInformation.map((el, index) => {
      return {
        ...el,
        dob: familyMemberDOB[index],
        mobile: FamilyPhone[index],
      };
    });

    data.familyInformation = familyData;

    const requestPayload = signupPayload(
      data,
      dateOfBirth,
      selectedOption,
      profileFile
    );

    if (isValid) {
      handleRegister(requestPayload);
    }
  };

  const handleChangeDate = (dates, index) => {
    setDobDate(...dates);
    dateValidation(...dates, dobDate);
  };

  const handleChangeFamilyMemberDate = (dates, index) => {
    const newFamilyMemberDOB = [...familyMemberDOB];
    newFamilyMemberDOB[index] = dates[0];
    setFamilyMemberDOB(newFamilyMemberDOB);
    dateValidation(...dates, newFamilyMemberDOB, index);
  };

  const dateValidation = (date, dateTwo, index, isTrue = false) => {
    let dateError = "";
    let familyMemberDobErr = "";

    if (!date) {
      dateError = "Date field is required.";
    } else {
      dateError = "";
    }

    if (familyMemberDOB[index]) {
      familyMemberDobErr = "Date field is required.";
    } else {
      familyMemberDobErr = "";
    }

    if (dateError) {
      setDateError(dateError);
      if (index !== -1) {
        const newFamilyMemberDOBError = [...familyMemberDOBError];
        newFamilyMemberDOBError[index] = familyMemberDobErr;
        setFamilyMemberDOBError(newFamilyMemberDOBError);
      } else if (isTrue) {
        setFamilyMemberDOBError(
          fields.map((el, i) =>
            familyMemberDOB[i] ? "" : "Date field is required."
          )
        );
      }
      return false;
    } else {
      setDateError(dateError);
      if (index !== -1) {
        const newFamilyMemberDOBError = [...familyMemberDOBError];
        newFamilyMemberDOBError[index] = familyMemberDobErr;
        setFamilyMemberDOBError(newFamilyMemberDOBError);
      }
      return true;
    }
  };

  const handleProfileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const blobURL = URL.createObjectURL(file);
      setProfilePic(blobURL);
      setProfileFile(file);
    }
  };
  const handleMoveToLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [signupSuccess]);

  return (
    <section className="registration-form-sec">
      <Container>
        <Form
          className="p-md-4 p-sm-2 px-0 text-start"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          autoComplete="off"
        >
          <div className="login-sec d-block pt-0 mb-2">
            <div class="common-heading text-center mb-5">
              <h2>Register New Member</h2>
            </div>
            {signupSuccess ? (
              <div className="wrapper mw-100 position-relative mb-5">
                <Row>
                  <Col md={12}>
                    <div className="success-check">
                      <SuccessCheck />
                    </div>
                    <div className="thanks-page">
                      <h2 className="text-center">
                        Thank you for submitting your information!
                      </h2>
                      <p className="text-center">
                        Your profile is under review. Please wait while an admin
                        verifies and approves it.
                      </p>
                      <p className="text-center">
                        You will receive an email shortly with your login
                        credentials.
                      </p>
                      <div className="text-center mt-4">
                        <button
                          className="btn-logins"
                          type="button"
                          onClick={() => handleMoveToLogin()}
                        >
                          Move to Login Page
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : (
              <>
                <MainMemberInfo
                  register={register}
                  errors={errors}
                  setPhone={setPhone}
                  phone={phone}
                  setValue={setValue}
                  dob={dobDate}
                  handleChangeDate={handleChangeDate}
                  dateError={dateError}
                  setProfilePic={setProfilePic}
                  profilePic={profilePic}
                  handleProfileUpload={handleProfileUpload}
                  setShowCropModal={setShowCropModal}
                  showCropModal={showCropModal}
                  setImageToCrop={setImageToCrop}
                  imageToCrop={imageToCrop}
                  setProfileFile={setProfileFile}
                />
                <ResidenceInfo register={register} errors={errors} />
                <VillageAddress register={register} errors={errors} />
                <OfficeInformation
                  register={register}
                  errors={errors}
                  setOfficePhone={setOfficePhone}
                  officePhone={officePhone}
                  setValue={setValue}
                />
                <DependentsInfo
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  familyMemberDOBError={familyMemberDOBError}
                  handleChangeFamilyMemberDate={handleChangeFamilyMemberDate}
                  familyMemberDOB={familyMemberDOB}
                  setFamilyPhone={setFamilyPhone}
                  FamilyPhone={FamilyPhone}
                  fields={fields}
                  append={append}
                  remove={remove}
                />
                <Payment
                  setSelectedOption={setSelectedOption}
                  selectedOption={selectedOption}
                  errors={errors}
                  watch={watch}
                  register={register}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  setError={setError}
                />
                <Button
                  type="submit"
                  className="themeht-btn btn w-100 py-2 mt-3"
                  onClick={() =>
                    dateValidation(dobDate, familyMemberDOB, -1, true)
                  }
                  disabled={loading}
                  style={
                    loading
                      ? { cursor: "not-allowed", background: "lightGray" }
                      : { cursor: "pointer" }
                  }
                >
                  <span className="d-flex fs-6 justify-content-center align-items-center">
                    Submit{" "}
                    {loading && (
                      <Loader
                        style={{
                          marginLeft: "20px",
                        }}
                        className="loader"
                      />
                    )}
                  </span>
                </Button>
              </>
            )}
          </div>
        </Form>
      </Container>
    </section>
  );
};

export default RegistrationForm;
